import { reducer } from "./reducer";
import { routes as componentRoutes } from "./components/componentRoutes";
import { Base } from "./components/Base";
import { routes } from "./routes";

export { reducer, componentRoutes, Base, routes };
